import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { ClientPackageProvider } from './lib/clientPackage';
import { TenantSettingsProvider } from './lib/tenantSettings';
import { App } from './App';
import { subscribeMode } from './lib/mode';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

// Every page's `useQuery` call reads whichever mode `lib/api.ts`'s `request()` sent on the
// request that's now cached - react-query has no idea the Test/Live switch exists, so without
// this it would keep showing stale Live-mode data after flipping to Test (or vice versa) until
// some unrelated state change happened to trigger a refetch. Invalidating every query on every
// mode change, globally, here, covers every page automatically - including ones written after
// this fix - rather than threading `mode` into 20+ individual queryKey arrays by hand.
subscribeMode(() => {
  void queryClient.invalidateQueries();
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element "#root" not found in index.html.');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ClientPackageProvider>
            <TenantSettingsProvider>
              <App />
            </TenantSettingsProvider>
          </ClientPackageProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
